import React, { useEffect, useState } from 'react';
import axiosInstance from '../../Services/axiosInstance';
import LoadingSpinner from '../common/LoadingSpinner';
import LogsTable from './LogsTable';
import { ScrollText, ShieldAlert } from 'lucide-react';
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
} from '../ui/card';

interface ProfileResponse {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  organisation: string;
  role: string;
}

const Logs: React.FC = () => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [profileLoading, setProfileLoading] = useState(true);

  useEffect(() => {
    const controller = new AbortController();

    axiosInstance.get<ProfileResponse>('/api/Profile', { signal: controller.signal })
      .then(res => {
        const role = res.data.role;
        setIsAdmin(role === 'Administrator' || role === 'Admin');
      })
      .catch(() => {
        setIsAdmin(false);
      })
      .finally(() => {
        if (!controller.signal.aborted) setProfileLoading(false);
      });

    return () => controller.abort();
  }, []);

  if (profileLoading) {
    return <LoadingSpinner label="Loading..." />;
  }

  if (!isAdmin) {
    return (
      <Card className="max-w-md mx-auto mt-12 animate-scale-in">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <div className="p-3 rounded-full bg-destructive/10">
              <ShieldAlert className="h-8 w-8 text-destructive" />
            </div>
          </div>
          <CardTitle>Access Denied</CardTitle>
          <CardDescription>
            You need administrator privileges to view application logs.
          </CardDescription>
        </CardHeader>
      </Card>
    );
  }

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-lg bg-primary/10">
              <ScrollText className="h-6 w-6 text-primary" />
            </div>
            <div>
              <CardTitle>Application Logs</CardTitle>
              <CardDescription>
                View and search application errors and warnings captured by the server.
              </CardDescription>
            </div>
          </div>
        </CardHeader>
      </Card>

      <LogsTable />
    </div>
  );
};

export default Logs;
